const apiUrl = 'https://proxy-shipping-fee.onrender.com';
const companyCep = '13348550 ';
const offeredShippingServices = '2,4,16,33';

/*
Services:
2 - SEDEX
4 - JadLog (.Com)
16 - Azul Cargo Express (ecommerce)
33 - J&T/JeT (Standard)
*/

const measurements = {
  bedPackage: {
    height: 20,
    width: 55,
    length: 59,
  },
  bowlPackage: {
    height: 10,
    width: 28,
    length: 29,
  },
  wearablesPackage: {
    height: 2,
    width: 30,
    length: 20,
  },
};

function applyCepMask(input) {
  let value = input.value;
  value = value.replace(/\D/g, ''); // Remove all non-digit characters
  value = value.replace(/(\d{5})(\d{3})/, '$1-$2'); // Insert a hyphen after the fifth character
  input.value = value;
}

function clearErrors() {
  const shippingErrors = document.querySelector('#shipping-errors');
  shippingErrors.innerText = '';
}

async function fetchShippingCost(formData) {
  try {
    const response = await fetch(`${apiUrl}/proxy/shipment/calculate`, {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'User-Agent': 'Aplicação bruno@woley.com',
        'Access-Control-Allow-Origin': '*',
      },
    });

    const responseText = await response.text();

    if (!response.ok) {
      console.error('Error response:', responseText);
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    if (responseText) {
      const data = JSON.parse(responseText);
      return data;
    } else {
      throw new Error('Received empty response');
    }
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;
  }
}

async function calculateShippingFee() {
  const shippingErrors = document.querySelector('#shipping-errors');
  const resultContainer = document.getElementById('result');
  const cepInput = document.querySelector('#shipping-fee-input');

  const productType = document.querySelector('.product-page-section').getAttribute('data-product-type');
  let productMeasurements = {};

  if (productType === 'Pet Bed') {
    productMeasurements = measurements.bedPackage;
  } else if (productType === 'Bowl' || 'Retractable bowl') {
    productMeasurements = measurements.bowlPackage;
  } else {
    productMeasurements = measurements.wearablesPackage;
  }

  const cepNumber = cepInput.value;
  const customerCep = cepNumber.replace(/\D/g, '');

  if (!customerCep || customerCep.length !== 8) {
    resultContainer.innerText = '';
    return (shippingErrors.innerText = 'O CEP precisa ter 8 dígitos.');
  }

  document.getElementById('shipping-loading').style.display = 'block';
  document.querySelector('.calculate-shipping-fee__button').disabled = true;

  try {
    const formData = {
      from: {
        postal_code: companyCep,
      },
      to: {
        postal_code: customerCep,
      },
      package: productMeasurements,
      services: offeredShippingServices,
    };

    const resultData = await fetchShippingCost(formData);

    if (resultData && resultData.length > 0) {
      resultData.sort((a, b) => a.price - b.price);

      let resultString = `<div> Custo de entrega para ${customerCep}:</div>`;
      resultData.forEach((shippingOption) => {
        const formattedPrice = Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        }).format(shippingOption.price);

        resultString += `
          <div class="shipping-results-data">
            <strong>${shippingOption.company.name} ${shippingOption.name}:</strong> ${formattedPrice}
            Prazo de entrega: ${shippingOption.delivery_time + 1} dias (entre ${shippingOption.delivery_range.min} e ${
          shippingOption.delivery_range.max + 1
        } dias)
          </div>
        `;
      });

      resultContainer.innerHTML = resultString;
      clearErrors();
    } else {
      resultContainer.innerText = 'Houve um problema ao processar o CEP inserido';
      clearErrors();
    }
  } catch (error) {
    console.error('Error in calculateShippingFee:', error); // Log the error for debugging
    document.getElementById('result').innerText = 'Um erro ocorreu.';
  } finally {
    document.getElementById('shipping-loading').style.display = 'none';
    document.querySelector('.calculate-shipping-fee__button').disabled = false;
  }
}

function getShippingInformation() {
  const button = document.querySelector('#shipping-fee-button');

  button.addEventListener('click', () => {
    calculateShippingFee();
  });
}

document.addEventListener('DOMContentLoaded', getShippingInformation);

document.addEventListener('DOMContentLoaded', function () {
  const cepInput = document.querySelector('#shipping-fee-input');
  cepInput.addEventListener('input', function () {
    applyCepMask(this);
  });
});
